import axios from 'axios';
import { User as FirebaseUser } from 'firebase/auth';

/**
 * Genera un link de reset de password para un usuario.
 * Solo superadmins pueden invocar este endpoint (validado server-side).
 *
 * @param targetUid - UID del usuario al que se le quiere generar el link
 * @param currentUser - Usuario autenticado actual (debe ser superadmin)
 * @returns El link de reset
 * @throws Error con mensaje legible si falla
 */
export async function generatePasswordResetLink(
  targetUid: string,
  currentUser: FirebaseUser | null
): Promise<string> {
  if (!currentUser) {
    throw new Error('No autenticado');
  }

  const token = await currentUser.getIdToken();
  const response = await axios.post(
    `/api/admin/users/${targetUid}/password-reset-link`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data.link;
}

/**
 * Extrae mensaje de error legible de una excepcion del helper.
 */
export function extractResetError(err: any): string {
  return (
    err?.response?.data?.error ||
    err?.response?.data?.details ||
    err?.message ||
    'Error generando link'
  );
}
